<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <genelfiltre ref="genelfiltre"></genelfiltre>

    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Coper {{$t('General-Purpose-Report')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-show="!dizaynView"
              flat=""
              solo-inverted=""
              hide-details
              v-model="search"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-menu bottom left>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile v-show="!dizaynView" @click="RaporGetirExcel()">
                  <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                </v-list-tile>

                <v-tooltip bottom>
                  <v-list-tile
                    slot="activator"
                    v-show="!dizaynView"
                    :disabled="!sayfayetki.Save"
                    @click="DizaynEkleSor()"
                  >
                    <v-list-tile-title>{{ $t('Add-Design') }}</v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Save">{{ $t('Add-Design') }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <v-list-tile
                    slot="activator"
                    v-show="!dizaynView"
                    :disabled="!sayfayetki.Update"
                    @click="DesignShow()"
                  >
                    <v-list-tile-title> {{ $t('Change-Design') }} </v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update"> {{ $t('Change-Design') }} </span>
                </v-tooltip>

                <v-tooltip bottom>
                  <v-list-tile
                    slot="activator"
                    :disabled="!sayfayetki.Delete"
                    @click="Dizaynsil()"
                  >
                    <v-list-tile-title> {{$t('Delete-Design')}} </v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Delete">{{ $t('Delete-Design') }}</span>
                </v-tooltip>

                <v-list-tile @click="islemIptal()" v-show="dizaynView">
                  <v-list-tile-title>{{ $t('Cancel-Process') }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>
        <v-container fluid>
          <v-flex pb-3 xs12 sm12 md12>
            <v-card flat>
              <v-layout v-show="!dizaynView" row wrap>
                <v-flex xs12 sm6 pt-2 md2>
                  <v-select
                    :label="$t('Date-Type')"
                    items-value="value"
                    item-text="text"
                    :items="itemstarihtip"
                    v-model="tarihTip"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 pt-2 md2>
                  <tarihim
                    :etiket="$t('Starting-Date')"
                    :detaygizle="false"
                    v-model="KayitTarihiBasla"
                    v-bind:defaultvalue="'ok'"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm6 pt-2 md2>
                  <tarihim
                    :etiket="$t('Finishing-Date')"
                    :detaygizle="false"
                    v-model="KayitTarihiBitis"
                    v-bind:defaultvalue="'ok'"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                  ></tarihim>
                </v-flex>

                <v-flex pt-2 xs12 sm4 md4>
                  <raporsablon
                    v-show="true"
                    ref="raporsablon"
                    :menudisable="false"
                    v-model="sablon"
                    :dizayngrupadi="dizayngrupadi"
                    :objectname="dizaynobjectname"
                  ></raporsablon>
                </v-flex>

                <v-flex pt-2>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn
                        color="info"
                        @click="RaporGetirExcel()"
                        fab
                        small=""
                        dark
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <v-badge color="white" :overlap="true">
                      <template v-slot:badge>
                        <v-icon v-if="filtrevarmi" large color="green">
                          check_circle_outline
                        </v-icon>
                      </template>

                      <v-btn
                        small=""
                        @mouseenter="tooltip = true"
                        @mouseleave="tooltip = false"
                        ref="fab"
                        @click="filtrele()"
                        color="info"
                        fab
                        dark
                      >
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{$t('Add-Search-Filter')}}</span>
                      </v-tooltip>
                    </v-badge>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-layout row wrap>
            <v-flex xs12 sm12 pt-1 pb-2 md12>
              <v-layout row wrap class="project overdue">
                <v-toolbar flat="" size="100px" dark color="white">
                  <v-toolbar-title>
                    <span class="title grey--text font-weight-">
                       {{$t('Report-will-provided-Excel')}}
                    </span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </v-layout>
            </v-flex>

            <v-flex v-show="!dizaynView" xs12 sm12>
              <v-card flat>
                <v-data-table
                  :headers="parseDesign()"
                  :items="desserts"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td
                      v-for="tableheader in parseDesign()"
                      :key="tableheader.id"
                    >
                      {{ props.item[tableheader.value] | generalFormat }}
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>

            <v-flex xs12 v-show="dizaynView" pa-2 sm12 md12>
              <v-card flat>
                <v-layout row wrap>
                  <v-flex xs6 sm6 md6>
                    <v-icon medium="" color="info">settings</v-icon> &nbsp;
                    <span class="font-weight-regular grey--text title">
                      {{ $t('Report-Design-Processes') }}</span
                    >
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-layout justify-end>
                      <v-tooltip bottom>
                        <v-btn
                          :disabled="!sayfayetki.Update"
                          color="info"
                          slot="activator"
                          @click="DizaynKaydet()"
                          flat
                        >
                          <span class="hidden-sm-and-down">
                            {{$t('Save-Design')}}
                          </span>
                          <v-icon right dark>create</v-icon>
                        </v-btn>
                        <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                        <span v-if="sayfayetki.Update">{{$t('Save-Design')}}</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <v-flex xs6 v-show="dizaynView" pa-2 md6 sm6>
              <v-card flat>
                <v-flex xs12 md12 sm12>
                  <v-flex xs12 sm12 md12>
                    <v-system-bar window color="info">
                      <span class="white--text subheading">
                        {{ $t('Unselected-Spaces') }}</span
                      >
                      <v-spacer></v-spacer>
                    </v-system-bar>
                  </v-flex>
                  <draggable
                    class="list-group"
                    tag="ul"
                    v-model="dizaynData"
                    v-bind="dragOptions"
                    :move="onMove"
                  >
                    <transition-group type="transition" :name="'flip-list'">
                      <v-list
                        v-for="element in dizaynData"
                        :key="element.text"
                        subheader
                      >
                        <v-list-tile>
                          <v-flex xs12 md12 sm12>
                            <v-icon color="grey">drag_handle </v-icon>
                            {{ element.text }}
                            <span class="grey--text caption">
                              ({{ element.value }})</span
                            >
                            <v-btn
                              small
                              color="green"
                              slot="activator"
                              @click="dialogacDuzenle(element, 1)"
                              flat
                            >
                              <v-icon small>edit</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-list-tile-action>
                            <v-btn icon ripple>
                              <v-icon
                                @click="
                                  ItemAktar(dizaynData, dizaynData2, element)
                                "
                                color="green"
                                >arrow_forward_ios
                              </v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </v-list>
                    </transition-group>
                  </draggable>
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex v-show="dizaynView" xs6 pa-2 md6 sm6>
              <v-card flat>
                <v-flex xs12 md12 sm12>
                  <v-flex xs12 sm12 md12>
                    <v-system-bar window color="info">
                      <span class="white--text subheading">
                        {{ $t('Selected-Spaces') }} </span
                      >
                      <v-spacer></v-spacer>
                    </v-system-bar>
                  </v-flex>

                  <draggable
                    element="span"
                    v-model="dizaynData2"
                    v-bind="dragOptions"
                    :move="onMove"
                  >
                    <transition-group name="no" class="list-group" tag="ul">
                      <v-list
                        v-for="element in dizaynData2"
                        :key="element.text"
                        subheader
                      >
                        <v-list-tile>
                          <v-flex xs12 md12 sm12>
                            <v-icon
                              @click="
                                ItemAktar(dizaynData2, dizaynData, element)
                              "
                              color="red"
                              >arrow_back_ios
                            </v-icon>
                            {{ element.text }}
                            <span class="grey--text caption">
                              ({{ element.value }})</span
                            >
                            <v-btn
                              small
                              :disabled="!sayfayetki.Update"
                              color="green"
                              slot="activator"
                              @click="dialogacDuzenle(element, 2)"
                              flat
                            >
                              <v-icon small>edit</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-list-tile-action>
                            <v-btn icon ripple>
                              <v-icon color="grey">drag_handle </v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </v-list>
                    </transition-group>
                  </draggable>
                </v-flex>
              </v-card>
            </v-flex>

            <v-snackbar
              :timeout="timeout"
              :top="y === 'top'"
              :bottom="y === 'bottom'"
              :right="x === 'right'"
              :left="x === 'left'"
              :multi-line="mode === 'multi-line'"
              :vertical="mode === 'vertical'"
              v-model="snackbar"
            >
              {{ text1 }}
              <v-btn flat color="pink" @click.native="snackbar = false"
                >{{$t('Close')}}</v-btn
              >
            </v-snackbar>

            <v-dialog v-model="dialogyenideger" persistent max-width="290">
              <v-card>
                <v-card-title class="headline"> {{ $t('Edit') }}  </v-card-title>
                <v-card-text>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      hide-details=""
                      v-model="yeniDeger"
                      :label="$t('Field-Title-Shown-Report')"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox label="Toplam" v-model="yeniDegerSum"></v-checkbox>
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="info" flat @click.native="yazdir1()"
                    >{{ $t('OK') }}</v-btn
                  >
                  <v-btn
                    color="info"
                    flat
                    @click.native="dialogyenideger = false"
                    >{{ $t("cancel_button") }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="dialogdizaynEkle"
              scrollable=""
              persistent=""
              max-width="400px"
            >
              <v-card color="grey lighten-4">
                <v-card-title> {{ $t('Add-Design') }} </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-flex ma-1 xs12 sm12 md12>
                    <v-layout row="" wrap="">
                      <div class="flex md12">
                        <v-text-field
                          hide-details=""
                          v-model="dizaynAdi"
                          :label="$t('Design-Name')"
                        ></v-text-field>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click.native="dialogdizaynEkle = false"
                    >{{ $t("cancel_button") }}</v-btn
                  >
                  <v-btn color="blue darken-1" flat @click="DizaynEkle()"
                    > {{ $t('Add') }} </v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-container>
        <v-container fluid>
          <v-layout row wrap> </v-layout>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import auth from "../../../../api/auth";
import tarihim from "@/components/app/customcomp/tarihim";

import helpers from "@/components/app/customcomp/helpers.js";
import draggable from "vuedraggable";
import tool from "@/components/app/coper/tools.js";
import raporsablon from "@/components/app/coper/comp/raporsablon.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import genelfiltre from "../comp/genelfiltre.vue";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      tarihTip: 0,
      itemstarihtip: genelfiltre.IslemTarihTip(),
      dizayngrupadi: "GenelAmacliRaporCoper",
      dizaynobjectname: "Models.GenelAmacliRaporCoper",
      loadingvmodel: false,
      islemdizisi: null,
      dialogyenideger: false,
      duzenlenenkayit: null,
      yeniDeger: null,
      yeniDegerSum:false,
      filtrevarmi: false,
      sablon: {
        design: [],
      },
      desserts: [],
      loadingana: false,

      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      
      prm: {},

      dragging: false,

      dizaynData2: [],
      dizaynData: [],
      dizaynView: false,
      dizaynAdi: null,
      dialogdizaynEkle: false,

      
      editable: true,
      isDragging: false,
      delayedDragging: false,

      search: "",

    
      islemdurumu: null,
      menu: false,
      modal: false,
     
     
      menu2: false,
      
      modal2: false,
      harekettipi: "",
      items: [],
      Rapor: genelfiltre.EmptyPrametre(), 

      tooltip: false,
      el: null,
      StartDate: null,
      EndDate: null,
      load: false,
      load1: true,

      progress: false,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      statecari: [],
      loading: false,
      searchcari: null,
      dialogfiltre: false,
      evraktipi: [],
      dictionary: {
        custom: {
          tarihsecbas: {
            required: () => this.$t('Please-select-a-date'),
          },
          tarihsecbit: {
            required: () => this.$t('Please-select-a-date'),
          },
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
  filters: {
    generalFormat: function (t) {
      var parsedDate = Date.parse(t);
      if (t != "" && isNaN(t) && !isNaN(parsedDate)) {
        if (new Date(t).getFullYear() > 1890) {
          if (t != "0001-01-01T00:00:00" && t != "" && t != null) {
            var date = new Date(t);
            var fulldate = date.toLocaleDateString("tr-TR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
            return fulldate;
          } else {
            return null;
          }

          //return tool.Date_yyyy_MM_dd(t);
        } else {
          return "";
        }
      }

      return t;
    },
   
  },
  methods: {
    dialogacDuzenle(a, b) {
      this.duzenlenenkayit = a;
      this.islemdizisi = b;
      this.yeniDeger = a.text;
      this.yeniDegerSum = a.Sum;
      this.dialogyenideger = true;
    },
    yazdir2() {
      var indexno = this.dizaynData2.indexOf(this.duzenlenenkayit);
      this.duzenlenenkayit.text = this.yeniDeger;
      this.duzenlenenkayit.Sum = this.yeniDegerSum;
      this.dizaynData2.splice(indexno, 1, this.duzenlenenkayit);
      this.dialogyenideger = false;
    },
    yazdir1() {
      var indexno = this.dizaynData.indexOf(this.duzenlenenkayit);
      this.duzenlenenkayit.text = this.yeniDeger;
      this.duzenlenenkayit.Sum = this.yeniDegerSum;
      this.dizaynData.splice(indexno, 1, this.duzenlenenkayit);
      this.dialogyenideger = false;
    },

    filtrele() {
      this.$refs.genelfiltre.open("").then((confirm) => {
        if (confirm.Status == true) {
          this.filtrevarmi = true;
          this.Rapor=confirm.Rapor;
          this.RaporGetirExcel();

        } else {
          this.filtrevarmi = false;
          this.Rapor=confirm.Rapor;
        }
      });

      //this.dialogfiltre = true;
      //var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    },

    DizaynEkleSor() {
      this.dialogdizaynEkle = true;
    },
    DizaynEkle() {
      tool
        .api_post(this, "RaporSablon/GetReportBroDesignInsert", {
          id: 0,
          ad: this.dizaynAdi,
          reportBroGrupAdi: this.dizayngrupadi,
          objectName: this.dizaynobjectname,
        })
        .then(
          (response) => {
            var prmm = {
              id: 0,
              ad: this.dizayngrupadi,
              objectName: this.dizaynobjectname,
            };

            this.$refs.raporsablon.sablonGetirout(prmm);
            this.dialogdizaynEkle = false;
            this.text1 = this.$t('Design-has-been-saved');
            this.snackbar = true;
            this.dizaynView = false;
          },
          (response) => {
            this.text1 = "Hata oluştu.";
            this.snackbar = true;
          }
        );
    },
    DizaynKaydet() {
      var d = [];
      var i;
      for (i = 0; i < this.dizaynData2.length; i++) {
        var items = {
          text: this.dizaynData2[i].text,
          value: this.dizaynData2[i].value,
          selected: true,
          Sum: this.dizaynData2[i].Sum
        };
        d.push(items);
      }
      for (i = 0; i < this.dizaynData.length; i++) {
        var items = {
          text: this.dizaynData[i].text,
          value: this.dizaynData[i].value,
          selected: false,
          Sum: this.dizaynData[i].Sum
        };
        d.push(items);
      }

      var djosn = JSON.stringify(d);

      tool
        .api_post(this, "RaporSablon/TableDesignSave", {
          id: this.sablon.id,
          design: djosn,
        })
        .then(
          (response) => {
            var prmm = {
              id: 0,
              ad: this.dizayngrupadi,
              objectName: this.dizaynobjectname,
            };

            this.$refs.raporsablon.sablonGetirout(prmm);

            this.text1 = this.$t('Design-has-been-saved');
            this.snackbar = true;
            this.dizaynView = false;
          },
          (response) => {
            this.status = tool.responseToStatus(response);
          }
        );
    },
    Dizaynsil() {
      tool
        .api_post(this, "RaporSablon/GetReportBroDesignDelete", {
          id: this.sablon.id,
          ad: this.sablon.ad,
          design: null,
        })
        .then(
          (response) => {
            var prmm = {
              id: 0,
              ad: this.dizayngrupadi,
              objectName: this.dizaynobjectname,
            };

            this.$refs.raporsablon.sablonGetirout(prmm);

            this.text1 = this.$t('Design-has-been-deleted');
            this.snackbar = true;
            this.dizaynView = false;
          },
          (response) => {}
        );
    },

    islemIptal() {
      this.dizaynView = false;
    },
    ItemAktar(kaynak, hedef, item) {
      var n = kaynak.indexOf(item);

      var temp = {
        text: item.text,
        value: item.value,
      };

      hedef.push(temp);
      kaynak.splice(n, 1);
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },

    DesignShow() {
      tool
        .api_post(this, "RaporSablon/TableDesignRead", {
          value: this.sablon.id,
        })
        .then(
          (response) => {
            var temp = JSON.parse(response.body);
            this.dizaynData2 = [];
            this.dizaynData = [];
            this.dizaynView = true;

            var i;
            for (i = 0; i < temp.length; i++) {
              if (temp[i].selected) {
                this.dizaynData2.push(temp[i]);
              } else {
                this.dizaynData.push(temp[i]);
              }
            }
          },
          (response) => {
            this.status = tool.responseToStatus(response);
            this.dizaynView = false;
          }
        );
    },

    parseDesign() {
      if (this.sablon.design.length > 0) {
        var temp = JSON.parse(this.sablon.design);
        var r = [];
        var i;
        for (i = 0; i < temp.length; i++) {
          if (temp[i].selected) {
            r.push(temp[i]);
          }
        }
        return r;
      } else {
        return [];
      }
    },
    RaporGetir: RaporGetir,
    RaporGetirExcel: RaporGetirExcel,
    getDateNow: getDateNow,
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },

    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
   
  },
  beforeMount: beforeMount,
  components: {
    draggable,
    tarihim,
    raporsablon,
    yetkidialog,
    loadingcomp,

    genelfiltre,
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.el = this.$refs.fab.$el;
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
};

function beforeMount() {}

function getDateNow() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = yyyy + "-" + mm + "-" + dd;
  return today;
}

function RaporGetir() {
  this.dialogfiltre = false;

  this.$validator.validateAll().then((result) => {
    if (result) {
      var bastarih = new Date(this.date);
      var bittarih = new Date(this.date2);

      if (bastarih <= bittarih) {
        var credentials = JSON.parse(
          window.localStorage.getItem("credentials")
        );

        this.progress = true;
        this.prm.BaslangicTarih = this.date;
        this.prm.BitisTarih = this.date2;
        this.prm.SirketKodu = credentials.SirketKodu;

        this.load1 = false;
        this.load = true;

        let params3 = {
          prm: {
            Prm: {},
          },
        };

        this.$refs.raporsablon.Report(params3).then(
          (confirm) => {
            this.desserts = confirm;
            this.load1 = true;
            this.load = false;
          },
          (confirm) => {
            this.desserts = [];
            this.load1 = true;
            this.load = false;
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date');
        this.snackbar = true;
      }
    }
  });
}

function RaporGetirExcel() {
  this.dialogfiltre = false;



  this.$validator.validateAll().then((result) => {
  if (this.sablon.design.length > 0) {
 
    if (result) {
      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);

      if (bastarih <= bittarih) {
        this.loadingvmodel = true;

        this.progress = true;

         let Rapor = genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis);

        let params = {
          prm: {
            Prm: genelfiltre.ParametreOlustur(Rapor),
            tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
            sayfaAdi:this.$route.name
          },
          objectName: this.dizaynobjectname,
          id: this.sablon.id,
        };

        this.load1 = false;
        this.load = true;

        tool
          .api_post_FileDownload(this, "RaporSablon/GetReportExcel", params)
          .then(
            (response) => {
              this.loadingvmodel = false;

              var blob = new Blob([response.data], {
                type: "application/xlsx",
              });
              var link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = this.dizayngrupadi + ".xlsx";
              link.click();
              this.progress = false;
              this.load1 = true;
              this.load = false;
            },
            (response) => {
              this.loadingvmodel = false;
              this.progress = false;
              this.load1 = true;
              this.load = false;
            }
          );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date');
        this.snackbar = true;
      }
    }
    }else{
       this.text1 = "Şablon alanı boş olamaz.";
        this.snackbar = true;
    }
  });
}








</script>

<style scoped>
.button {
  margin-top: 35px;
}

.handle {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
}

.close {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}

input {
  display: inline-block;
  width: 50%;
}

.text {
  margin: 20px;
}
</style>
